module.exports = "/_next/static/images/babydoge-dba09205f52b42dec42fed376a9eb808.svg";